module.exports = __webpack_public_path__ + "img/bell_brown.b931500f.svg";